import { Component, h, JSX, Prop, Element } from '@stencil/core';

@Component({
  tag: 'rcm-headline',
  styleUrl: 'rcm-headline.scss',
  shadow: false,
})
export class RcmHeadline {
  /** Headline level (from 1 to 4) */
  @Prop() public level = 1;

  /** Headline level style (if different style than level) */
  @Prop() public levelStyle: number;

  /** Text of the headline */
  @Prop() public headline: string;

  /** Weight of the headline */
  @Prop() public bold: boolean;

  @Prop() public light: boolean;

  @Prop() public regular: boolean;

  /** internal use - for use on Stage */
  @Prop() public xl: boolean;

  @Prop() public fontSize: string;

  @Prop() public lineHeight: string;

  @Prop() public color: string;

  @Prop() public bolditalic: boolean;

  @Element() private element: HTMLRcmHeadlineElement;

  public render(): JSX.Element {
    const level = Math.min(5, this.level);
    const HeadlineTag = `h${level}`;
    const headlineStyle = this.levelStyle ? Math.min(5, this.levelStyle) : level;
    const headlineClasses = {
      headline: true,
      [`headline--${headlineStyle}`]: true,
      'headline--bold': this.bold,
      'headline--light': this.light,
      'headline--regular': this.regular,
      'headline--xl': this.xl,
      'headline--bolditalic': this.bolditalic,
    };

    const styleProps: {
      [key: string]: string;
    } = {};
    if (this.fontSize) {
      styleProps.fontSize = this.fontSize;
    }
    if (this.lineHeight) {
      styleProps.lineHeight = this.lineHeight;
    }
    if (this.color) {
      styleProps.color = this.color;
    }

    return <HeadlineTag class={headlineClasses} innerHTML={this.headline} style={{ ...styleProps }}></HeadlineTag>;
  }
}
